import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'

import { BASE_PAGE } from '@app/constants/page'

import { PermissionWrapper } from '@app/components'

import type { PermissionRouteProps } from './types'

export const PermissionRoute: React.FC<PermissionRouteProps> = ({
  to = BASE_PAGE.root,
  requiredRoles = [],
  requiredPermissions = [],
  children
}) => {
  const fallback = (
    <Navigate
      to={ to }
      replace
    />
  )

  const content = children ?? <Outlet />

  return (
    <PermissionWrapper
      requiredRoles={ requiredRoles }
      requiredPermissions={ requiredPermissions }
      fallback={ fallback }
    >
      { content }
    </PermissionWrapper>
  )
}
